module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.401b6f7e.worker.js");
}
